export default class IframeControl extends HTMLElement {
    readonly #textArea: HTMLTextAreaElement | null = this.querySelector('textarea');

    readonly #select: HTMLSelectElement | null = this.querySelector('select');

    readonly #width = this.getAttribute('width') ?? '';

    readonly #height = this.getAttribute('height') ?? '';

    public connectedCallback(): void {
        this.#select?.addEventListener('change', this.#renderIframeCode.bind(this));
        this.#renderIframeCode();
    }

    public disconnectedCallback(): void {
        this.#select?.removeEventListener('change', this.#renderIframeCode.bind(this));
    }

    #renderIframeCode(): void {
        if (this.#textArea === null || this.#select === null) {
            return;
        }

        const value = `<iframe style="height: ${this.#height}; width: ${this.#width}" src="${
            this.#select.value
        }"></iframe>`.trimStart();
        this.#textArea.value = value.trimStart();
    }
}

if (!customElements.get('iframe-control')) {
    customElements.define('iframe-control', IframeControl);
}
